import { createFileRoute } from "@tanstack/react-router";
import { WebhooksScreen } from "./-settings/WebhooksScreen";

export const Route = createFileRoute("/$workspace/$project/settings/webhooks")({
  staticData: { title: "Webhooks" },
  component: WebhooksScreen,
});
